const API_BASE = (process.env.REACT_APP_API_URL || "").replace("/graphql", "");

export interface SessionInfo {
  restaurant_id: number;
  branch_id: number;
  restaurant_name: string;
  restaurant_logo: string;
  host_name: string;
  guest_count: number;
  max_guests: number;
  expires_at: string;
}

export interface JoinResponse {
  guest_token: string;
  guest_name: string;
}

export interface CartProduct {
  id: number;
  name: string;
  price: number;
  ingredients_txt?: string;
}

export interface MyProductsResponse {
  products: CartProduct[];
  total: number;
}

export interface AddProductPayload {
  guest_token: string;
  product_id: number;
  size?: number | null;
  ingredients?: number[];
  ingredients_opt?: number[];
  ingredients_txt?: string;
  comments?: string;
}

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || body.error || `Error ${res.status}`);
  }
  return res.json();
}

export const sharedCartApi = {
  getSession: (token: string): Promise<SessionInfo> =>
    fetch(`${API_BASE}/api/shared-cart/${token}`).then((r) =>
      handleResponse<SessionInfo>(r)
    ),

  join: (token: string, name: string): Promise<JoinResponse> =>
    fetch(`${API_BASE}/api/shared-cart/${token}/join`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name }),
    }).then((r) => handleResponse<JoinResponse>(r)),

  addProduct: (
    token: string,
    payload: AddProductPayload
  ): Promise<{ success: boolean; product: { id: number; price: number; name: string } }> =>
    fetch(`${API_BASE}/api/shared-cart/${token}/add-product`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).then((r) => handleResponse(r)),

  getMyProducts: (
    token: string,
    guestToken: string
  ): Promise<MyProductsResponse> =>
    fetch(`${API_BASE}/api/shared-cart/${token}/my-products`, {
      headers: { "X-Guest-Token": guestToken },
    }).then((r) => handleResponse<MyProductsResponse>(r)),

  deleteProduct: (
    token: string,
    guestToken: string,
    productId: number
  ): Promise<{ success: boolean }> =>
    fetch(`${API_BASE}/api/shared-cart/${token}/product/${productId}`, {
      method: "DELETE",
      headers: { "X-Guest-Token": guestToken },
    }).then((r) => handleResponse(r)),
};
